import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";

import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconShadowUrl from "leaflet/dist/images/marker-shadow.png";

// Leaflet's default marker URLs reference paths that bundlers don't resolve;
// recreate the default icon with the imported images.
const DefaultIcon = L.icon({
    iconUrl,
    iconRetinaUrl,
    shadowUrl: iconShadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

function ClickToMove({ onMove }) {
    useMapEvents({
        click(e) { onMove(e.latlng.lat, e.latlng.lng); },
    });
    return null;
}

function PanWhenLatLonChanges({ lat, lon }) {
    const map = useMap();
    useEffect(() => {
        if (lat == null || lon == null) return;
        map.setView([lat, lon], map.getZoom(), { animate: true });
    }, [lat, lon, map]);
    return null;
}

/**
 * Tiny wrapper around Leaflet for picking a lat/lon. Click anywhere on the
 * map OR drag the marker to move it. Uses OpenStreetMap tiles (no API key).
 */
export default function LocationPickerMap({ lat, lon, onChange, height = 280 }) {
    const markerRef = useRef(null);
    const validLat = typeof lat === "number" && !Number.isNaN(lat) ? lat : 53.3498;
    const validLon = typeof lon === "number" && !Number.isNaN(lon) ? lon : -6.2603;

    const onDragEnd = () => {
        const m = markerRef.current;
        if (!m) return;
        const { lat: newLat, lng: newLon } = m.getLatLng();
        onChange(newLat, newLon);
    };

    return (
        <div
            className="rounded-md overflow-hidden border border-[var(--vm-border)]"
            style={{ height }}
            data-testid="location-picker-map"
        >
            <MapContainer
                center={[validLat, validLon]}
                zoom={6}
                scrollWheelZoom={false}
                style={{ height: "100%", width: "100%" }}
                className="paper-texture"
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <PanWhenLatLonChanges lat={validLat} lon={validLon} />
                <ClickToMove onMove={onChange} />
                <Marker
                    position={[validLat, validLon]}
                    draggable
                    eventHandlers={{ dragend: onDragEnd }}
                    ref={markerRef}
                />
            </MapContainer>
        </div>
    );
}
